<template>
  <header class="page-header">
    <div class="container">
      <div
        class="header-inner d-flex align-items-center justify-content-center"
      >
        <a href="/" class="logo-container">
          <img
            src="/images/logo.svg"
            alt="Axilweb LOGO"
            width="180"
            height="54"
          />
        </a>
        <div class="header-top-menu">
          <a
            v-if="adminPortalUrl"
            class="applicant-admin-portal"
            :href="adminPortalUrl"
          >
            Admin Portal</a
          >
          <span class="devider" v-if="adminPortalUrl">|</span>
          <a v-if="logoutUrl" class="applicant-signout" :href="logoutUrl"
            ><span><i class="far fa-sign-out"></i></span> Sign Out</a
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    logoutUrl: { type: String, default: false },
    adminPortalUrl: { type: String, default: false },
  },
};
</script>

<style lang="scss" scoped>
.header-inner {
  padding: 2.2rem 0 2.3rem;
  border-bottom: 0.1rem solid var(--border-color);
  position: relative;
  .header-top-menu {
    position: absolute;
    right: 0;
    z-index: 5;
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    .devider {
      margin: 0 10px;
    }
    i {
      padding-right: 6px;
    }
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    .header-top-menu {
      margin-top: 10px;
      position: static;
    }
  }
}
</style>
